import { motion } from 'motion/react';

import { cn } from '@workspace/shadcn';

import {
  BACKGROUND_LINE_COLORS,
  BACKGROUND_LINE_PATHS,
} from './background-lines-data.ts';

const pathVariants = {
  initial: { strokeDashoffset: 800, strokeDasharray: '50 800' },
  animate: {
    strokeDashoffset: 0,
    strokeDasharray: '20 800',
    opacity: [0, 1, 1, 0],
  },
};

function Lines({ duration = 10 }: { duration?: number }) {
  return (
    <motion.svg
      viewBox="0 0 1440 900"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      className="absolute inset-0 h-full w-full"
    >
      {['first', 'second'].map((pass) =>
        BACKGROUND_LINE_PATHS.map((path, index) => (
          <motion.path
            key={`${pass}-${index}`}
            d={path}
            stroke={BACKGROUND_LINE_COLORS[index]}
            strokeWidth="2.3"
            strokeLinecap="round"
            variants={pathVariants}
            initial="initial"
            animate="animate"
            transition={{
              duration,
              ease: 'linear',
              repeat: Infinity,
              repeatType: 'loop',
              delay: Math.floor(Math.random() * 10),
              repeatDelay: Math.floor(Math.random() * 10 + 2),
            }}
          />
        )),
      )}
    </motion.svg>
  );
}

export function BackgroundLines({
  children,
  className,
  duration,
}: {
  children?: React.ReactNode;
  className?: string;
  duration?: number;
}) {
  return (
    <div className={cn('bg-background h-[20rem] w-full md:h-screen', className)}>
      <Lines duration={duration} />
      {children}
    </div>
  );
}
